/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
/* eslint-disable import/prefer-default-export */
import * as ActionTypes from '../constants/ActionTypes';
import ConfigManager from '../helper/ConfigManager';
import gatewayClient from '../helper/GatewayClient';
import { accessManager } from '../helper/AccessManager';

const CONFIG = ConfigManager.config.gatewayClientConfig;

export function saveUserSettings(id, settings) {
	return async (dispatch) => {

		const mutation = `
		mutation UpdateUserSettings($id: ID!, $settings: UserSettingsInput!) {
			updateUserSettings(id: $id, settings: $settings) {
				success
				code
				fieldErrors {
					locale
				}
			}
		}
		`;

		try {
			await gatewayClient.graphql(mutation, { id, settings });
		} catch (error) {
			dispatch({ type: ActionTypes.ERROR, error });
		}
	};
}

const doLogin = async (request, dispatch) => {
	try {
		await gatewayClient.connect(CONFIG);
		const resp = await gatewayClient.authenticate(request);
		return resp.response || resp;
	} catch (error) {
		dispatch({ type: ActionTypes.ERROR });
		return { error: error.error };
	}
};

export function login(credentials, redirect) {
	return (dispatch) =>
		doLogin(credentials, dispatch).then((response) => {
			if (!response.error && response.token) {
				accessManager.loginUI(response.token, redirect);
				return true;
			}
			return response;
		});
}
export function pathLogin(pathname) {
	return (dispatch) =>
		doLogin({ pathname }, dispatch).then((result) => {
			accessManager.loginWithToken(result);
			return result;
		});
}

const doLogout = async (token, dispatch) => {
	try {
		await gatewayClient.connect({ ...CONFIG });
		gatewayClient.logout(token);
	} catch (err) {
		dispatch({ type: ActionTypes.ERROR, err });
		throw err;
	}
};

export function logout(token) {
	return async (dispatch) => {
		await doLogout(token, dispatch);
		accessManager.logoutUI();
	};
}
export function pathLogout(token) {
	return (dispatch) => doLogout(token, dispatch).catch((/* ignore */) => null);
}
